import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import "./App.css";
import TextBoxToJson from "./components/textBoxToJson";
import MapWidget from "./widget/mapWidget";
import HomePage from "./Homepage";
import LoginPage from "./landingPage/LoginPage";
import PricesPage from "./landingPage/Prices";
import FaqPage from "./landingPage/Faq";
import BusinessPages from "./newBusinessPages/businessPages";
import MenuWidget from "./widget/menuWidget";
import Privacy from "./landingPage/Privacy";
import MapliApp from "./landingPage/MapliApp";
import Test from "./testpage";
import BookingConfirmed from "./newBusinessPages/Bookingconfirmed";
import PaymentSuccess from "./newBusinessPages/PaymentSuccess";
import GetCityLocationsAdmin from "./landingPage/getLocationsAdmin";
import NewLandingPreview from "./newLandingV2/NewLandingPreview";
import OversiktPreview from "./newLandingV2/OversiktPreview";
import NotFound from "./landingPage/NotFound";

function App() {
  return (
    <>
      <Routes>
        <Route path='/' element={<NewLandingPreview />} />
        <Route path='/new-landing-preview' element={<NewLandingPreview />} />
        <Route path='/old-landing-preview' element={<HomePage />} />
        <Route path='/new-oversikt-preview' element={<OversiktPreview />} />
        <Route path='/no/:country/:city/:category' element={<OversiktPreview />} />
        <Route path='/en/:country/:city/:category' element={<OversiktPreview />} />
        <Route path='/no/:country/:city/:category/:place' element={<OversiktPreview />} />
        <Route path='/en/:country/:city/:category/:place' element={<OversiktPreview />} />
        <Route path='/pricesz' element={<Test />} />
        <Route path='/locationAdmin' element={<GetCityLocationsAdmin />} />
        <Route path='/mapliApp' element={<MapliApp />} />
        <Route path='/payment-success' element={<PaymentSuccess />} />
        <Route path='/booking-confirmed' element={<BookingConfirmed />} />
        <Route path='/faq' element={<FaqPage />} />
        <Route path='/privacy' element={<Privacy />} />
        <Route path='/login' element={<LoginPage />} />
        <Route path='/login/:page' element={<LoginPage />} />
        <Route path='/login/:page' element={<LoginPage />} />
        <Route path='/mapWidget' element={<MapWidget />} />
        <Route path='/menuWidget/:menu' element={<MenuWidget />} />
        <Route path='/myBusiness' element={<BusinessPages />} />
        <Route path='/myBusiness/:page' element={<BusinessPages />} />
        <Route path='/myBusiness/:page/:edit' element={<BusinessPages />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
